import React from 'react'

const MAP_TOKEN = process.env.GATSBY_MAPBOX_TOKEN
const MAP_ACCOUNT = process.env.GATSBY_MAPBOX_ACCOUNT

interface StaticMapProps {
  lng?: string
  lat?: string
  zoom?: number
  width?: number
  height?: number
  pinColor?: string
  mapStyles?: string
  pinSize?: 's' | 'l'
  className: string
}

const StaticMap: React.FC<StaticMapProps> = ({
  lng = '0',
  lat = '0',
  zoom = 0,
  width = 640,
  height = 480,
  pinColor = '232452',
  mapStyles = 'streets-v12',
  pinSize = 's',
  className = ''
}) => {
  const fixedLng = parseFloat(lng).toFixed(4)
  const fixedLat = parseFloat(lat).toFixed(4)

  const mapSize = `${width}x${height}@2x`
  const coords = `${fixedLng},${fixedLat},${zoom},0` // lng, lat, zoom, bearing
  const marker = `pin-${pinSize}+${pinColor}(${fixedLng},${fixedLat})`

  return (
    <img
      className={className}
      loading="lazy"
      src={`https://api.mapbox.com/styles/v1/${MAP_ACCOUNT}/${mapStyles}/static/${marker}/${coords}/${mapSize}?access_token=${MAP_TOKEN}`}
    />
  )
}

export default StaticMap
